// extracted by mini-css-extract-plugin
export default {"container":"Rates_container__Ic-t0","content":"Rates_content__p6ldG"};